export enum ClaimRoutePaths {
  Select = '/claim',
  Confirm = 'confirm',
  Status = 'status',
}
